//The logic for the alphabet listing to filter results by starting letter
$(".services-index .alpha-listing > li > a").on('click', function () {

    if ($(this).parent().hasClass("disabled")) {
        return;
    }

    //in case more than one section appears on the same page lets ensure our actions are only affecting this section
    var scopedSection = $(this).closest('section.services-index');
    var selectedLetter = $(this).parent().data('filter-letter');
    var currentLetter = scopedSection.find('.alpha-listing').data('current-letter');

    //Changing selected letter, hide the pagination and any result that doesn't start with that letter
    if (selectedLetter != currentLetter && selectedLetter != "ALL") {
        disablePagination(scopedSection);
        filterByLetter(scopedSection, selectedLetter);
    //Selected the already selected letter, show all the results and restore the pagination
    } else {
        resetLetterFilter(scopedSection);
        filterByLetter(scopedSection, "ALL");
        enablePagination(scopedSection);
    }
})

//The logic for pagination
$(".services-index .pagination-container").each(function () {

    var totalPages = $(this).data('total-pages');

    //Bind the click event for performing pagination
    $(this).find("a[data-target-page]").on('click', function () {

        //in case more than one section appears on the same page lets ensure our actions are only affecting this section
        var scopedSection = $(this).closest('section.services-index');

        var currentPage = scopedSection.find(".pagination-container li.pagination-list-link-active a");
        var selectedPage = $(this).data('target-page');

        if (selectedPage === "previous") {
            selectedPage = $(currentPage).data('target-page') - 1;
        }

        if (selectedPage === "next") {
            selectedPage = $(currentPage).data('target-page') + 1;
        }

        //Trying to navigate to the page we're already on, do nothing
        if (scopedSection.find("a[data-target-page='" + selectedPage + "']").closest('li').hasClass("pagination-list-link-active")) {
            return;
        }

        //Navigate to the page by changing the selected pagination item and hiding/showing the correct content
        scopedSection.find(".pagination-container a:not([data-target-page='" + selectedPage + "'])").closest('li').removeClass("pagination-list-link-active");
        scopedSection.find(".pagination-container a:not([data-target-page='" + selectedPage + "'])").removeClass("active");

        scopedSection.find(".pagination-container a[data-target-page='" + selectedPage + "']").not(".jump-nav").closest('li').addClass("pagination-list-link-active");
        scopedSection.find(".pagination-container a[data-target-page='" + selectedPage + "']").not(".jump-nav").addClass("active");

        scopedSection.find(".result-listing .result-card:not([data-page-number='" + selectedPage + "'])").hide();
        scopedSection.find(".result-listing .result-card[data-page-number='" + selectedPage + "']").show();

        //If we're on the first page then disable the jump-nav for the start
        if (selectedPage == 1) {
            scopedSection.find(".pagination-container a.jump-nav[data-target-page='previous']").addClass("invisible");
        } else {
            scopedSection.find(".pagination-container a.jump-nav[data-target-page='previous']").removeClass("invisible");
        }

        //If we're on the last page then disable the jump-nav for the end
        if (selectedPage == totalPages) {
            scopedSection.find(".pagination-container a.jump-nav[data-target-page='next']").addClass("invisible");
        } else {
            scopedSection.find(".pagination-container a.jump-nav[data-target-page='next']").removeClass("invisible");
        }

        //After changing pages scroll back to the top of the section
        $('html, body').animate({
            scrollTop: scopedSection.offset().top
        }, 100);
    })

})

function disablePagination(scopedSection) {
    scopedSection.find('.pagination-container').hide();
    scopedSection.find(".pagination-container a[data-target-page]").removeClass("disabled");
    scopedSection.find(".pagination-container a[data-target-page]").closest('li').removeClass("pagination-list-link-active");
    scopedSection.find(".pagination-container a[data-target-page]").removeClass("active");
}

function enablePagination(scopedSection) {
    scopedSection.find('.pagination-container').show();

    //Navigate to page 1.  TODO: Make this not a click, call functions directly
    scopedSection.find(".pagination-container a[data-target-page='1']").click();
}

function filterByLetter(scopedSection, selectedLetter) {

    //if not selecting "ALL", hide all other letters, show selected letter
    if (selectedLetter != "ALL") {
        scopedSection.find(".result-listing .result-card:not([data-start-letter='" + selectedLetter + "'])").hide();
        scopedSection.find(".result-listing .result-card[data-start-letter='" + selectedLetter + "']").show();
    }

    scopedSection.find('.alpha-listing').data('current-letter', selectedLetter);
    scopedSection.find(".alpha-listing li a").removeClass("selected");
    scopedSection.find(".alpha-listing li[data-filter-letter='" + selectedLetter + "'] a").addClass("selected");
}

function resetLetterFilter(scopedSection) {
    scopedSection.find('.result-listing .result-card').show();
    scopedSection.find('.alpha-listing').data('current-letter', "");
    scopedSection.find(".alpha-listing li a").removeClass("selected");
}